/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { ScopeQuestionOptionalValue } from '../../types/surveyScope';
import { Column, Divider } from '../tracking-list';

export interface ColumnCheckboxProps {
  isSelected: boolean;
  handleClick: () => void;
  question: ScopeQuestionOptionalValue;
  className?: string;
}

export const ColumnCheckbox = (props: ColumnCheckboxProps) => {
  const { isSelected, handleClick, className } = props;

  return (
    <>
      <Divider />
      <Column className={`combined-utrs-list__select-box ${className ?? ''}`} >
        <Button color='link' onClick={handleClick} className='p-0'>
          <i className={`${isSelected ? 'fa-solid fa-square-check text-ThemeAccentMedium' : 'fa-light fa-square text-ThemeNeutralsDark'}`} />
        </Button>
      </Column>
    </>
  );
}
